import { ITableColumn } from '../../../../../../../../components/UIWidgets/TableWrapper/models';
import { ICurrencyFormatter } from '../../../../../../../../services/selectors/portfolio';

export function getTopPositionsByPnLColumns(portfolioCurrencyFormatter: ICurrencyFormatter): ITableColumn[] {
  return [
    {
      label: 'Instrument Name',
      dataKey: 'instrumentName',
      flexGrow: 2,
      display: true,
      width: 400,
      disableSort: false,
    },
    {
      label: 'Custodian',
      dataKey: 'custodianName',
      flexGrow: 2,
      display: true,
      width: 200,
      disableSort: false,
    },
    {
      label: 'Quantity',
      dataKey: 'openQuantity',
      flexGrow: 2,
      display: true,
      width: 200,
      disableSort: false,
    },
    {
      label: `Current Value (${portfolioCurrencyFormatter()})`,
      dataKey: 'pnlMarketBase',
      flexGrow: 2,
      display: true,
      width: 200,
      disableSort: false,
    },
    {
      label: '% of Portfolio P&L',
      dataKey: 'portfolioPercentage',
      flexGrow: 2,
      display: true,
      width: 200,
      disableSort: false,
    },
    /*{
      label: `Realized P&L (${portfolioCurrencyFormatter()})`,
      dataKey: 'realizedPL',
      flexGrow: 2,
      display: true,
      width: 200,
      disableSort: false,
    },
    {
      label: `Unrealized P&L (${portfolioCurrencyFormatter()})`,
      dataKey: 'unrealizedPL',
      flexGrow: 2,
      display: true,
      width: 200,
      disableSort: false,
    },*/
    {
      label: `Total P&L (${portfolioCurrencyFormatter()})`,
      dataKey: 'pnlBase',
      flexGrow: 2,
      display: true,
      width: 200,
      disableSort: false,
    },
  ];
}
